import { render, staticRenderFns } from "./MenuSettings.vue?vue&type=template&id=0a723692&scoped=true&"
import script from "./MenuSettings.vue?vue&type=script&lang=js&"
export * from "./MenuSettings.vue?vue&type=script&lang=js&"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&lang=css&"
import style1 from "./MenuSettings.vue?vue&type=style&index=1&id=0a723692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a723692",
  null
  
)

export default component.exports